import api from "./api";

export const callGetActiveLotto = async (withTickets = false) => {
  try {
    return await api.get(`/lotto/web/active?withTickets=${withTickets}`);
  } catch (error) {
    console.log("Error callGetActiveLotto");
    return error?.response;
  }
};

export const callGetActiveLottoTickets = async () => {
  try {
    return await api.get(`/lotto/web/active/tickets`);
  } catch (error) {
    console.log("Error callGetActiveLottoTickets");
    return error?.response || { status: 500 };
  }
};

export const callGetDashboardLottos = async (page, offset) => {
  try {
    return await api.get(`/lotto/dashboard/all?page=${page}&offset=${offset}`);
  } catch (error) {
    console.log("Error callGetDashboardLottos");
    return error?.response || { status: 500 };
  }
};

export const callCreateDashboardLotto = async (data, photos) => {
  try {
    const formData = new FormData();

    // Agregar el objeto 'lotto' como JSON serializado
    const lottoBlob = new Blob([JSON.stringify(data)], {
      type: "application/json",
    });
    formData.append("lotto", lottoBlob);

    // Agregar las fotos si existen
    if (photos && photos.length > 0) {
      photos.forEach((file, index) => {
        formData.append("photos", file); // No uses photos[index], usa el mismo nombre para todos
      });
    }

    return await api.post(`/lotto/dashboard/create`, formData, { headers: { "Content-Type": "multipart/form-data" } });
  } catch (error) {
    console.log("Error callCreateDashboardLotto");
    return error?.response || { status: 500 };
  }
};

export const callUpdateDashboardLotto = async (data, photos) => {
  try {
    const formData = new FormData();

    // Agregar el objeto 'lotto' como JSON serializado
    const lottoBlob = new Blob([JSON.stringify(data)], {
      type: "application/json",
    });
    formData.append("lotto", lottoBlob);

    // Agregar las fotos si existen
    if (photos && photos.length > 0) {
      photos.forEach((file, index) => {
        formData.append("photos", file);
      });
    }

    return await api.put(`/lotto/dashboard/update/${data.lottoId}`, formData, { headers: { "Content-Type": "multipart/form-data" } });
  } catch (error) {
    console.log("Error callUpdateDashboardLotto");
    return error?.response || { status: 500 };
  }
};

export const callUpdateStatusLotto = async (data) => {
  try {
    return await api.put(`/lotto/dashboard/update/${data.lottoId}/status/${data.status}`, null, { headers: { "Content-Type": "application/json" } });
  } catch (error) {
    console.log("Error callUpdateDashboardLottoStatus");
    return error?.response || { status: 500 };
  }
};

export const callGetLottosByStatusNoPageable = async (data) => {
  try {
    const statusPath = data.status.join(",");
    return await api.get(`/lotto/dashboard/lottos/by/status/${statusPath}`);
  } catch (error) {
    console.log("Error callGetLottosByStatusNoPageable");
    return error?.response || { status: 500 };
  }
};

export const callDownloadExcelTicketMovements = async (action, lottoId) => {
  try {
    const response = await api.get(
      `/lotto/dashboard/${action}/excel/tickets/lotto/${lottoId}`,
      {
        responseType: "blob", // 👈 importante para manejar binarios
      }
    );

    // Crear un Blob con el contenido
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Crear URL temporal
    const url = window.URL.createObjectURL(blob);

    // Crear enlace y simular click
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `Tickets_Movements_LottoID-${lottoId}.xlsx`
    );
    document.body.appendChild(link);
    link.click();

    // Limpiar
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);

    return { status: 200 }; // puedes devolver un flag de éxito
  } catch (error) {
    console.error("Error callDownloadExcelTicketMovements", error);
    return error.response || { status: 500 };
  }
};